var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M10.5 2.25V5.25C10.5 5.66421 10.8358 6 11.25 6H14.25",
    stroke: "#0084B1",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M8.625 16.35C8.95637 16.35 9.225 16.0814 9.225 15.75C9.225 15.4186 8.95637 15.15 8.625 15.15V16.35ZM10.5 2.25L10.9243 1.82574C10.8117 1.71321 10.6591 1.65 10.5 1.65V2.25ZM14.25 6H14.85C14.85 5.84087 14.7868 5.68826 14.6743 5.57574L14.25 6ZM13.65 9.75C13.65 10.0814 13.9186 10.35 14.25 10.35C14.5814 10.35 14.85 10.0814 14.85 9.75H13.65ZM10.5 13.65C10.1686 13.65 9.9 13.9186 9.9 14.25C9.9 14.5814 10.1686 14.85 10.5 14.85V13.65ZM15.75 14.85C16.0814 14.85 16.35 14.5814 16.35 14.25C16.35 13.9186 16.0814 13.65 15.75 13.65V14.85ZM13.9243 11.5757C13.6899 11.3414 13.3101 11.3414 13.0757 11.5757C12.8414 11.8101 12.8414 12.1899 13.0757 12.4243L13.9243 11.5757ZM15.75 14.25L16.1743 14.6743C16.4086 14.4399 16.4086 14.0601 16.1743 13.8257L15.75 14.25ZM13.0757 16.0757C12.8414 16.3101 12.8414 16.6899 13.0757 16.9243C13.3101 17.1586 13.6899 17.1586 13.9243 16.9243L13.0757 16.0757ZM8.625 15.15H5.25V16.35H8.625V15.15ZM5.25 15.15C4.75294 15.15 4.35 14.7471 4.35 14.25H3.15C3.15 15.4098 4.0902 16.35 5.25 16.35V15.15ZM4.35 14.25V3.75H3.15V14.25H4.35ZM4.35 3.75C4.35 3.25294 4.75294 2.85 5.25 2.85V1.65C4.0902 1.65 3.15 2.5902 3.15 3.75H4.35ZM5.25 2.85H10.5V1.65H5.25V2.85ZM10.0757 2.67426L13.8257 6.42426L14.6743 5.57574L10.9243 1.82574L10.0757 2.67426ZM13.65 6V9.75H14.85V6H13.65ZM10.5 14.85H15.75V13.65H10.5V14.85ZM13.0757 12.4243L15.3257 14.6743L16.1743 13.8257L13.9243 11.5757L13.0757 12.4243ZM15.3257 13.8257L13.0757 16.0757L13.9243 16.9243L16.1743 14.6743L15.3257 13.8257Z",
    fill: "#0084B1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadFile);
export default __webpack_public_path__ + "static/media/downloadFile.30bc89db9a5fdec5015dcb9c0381b5db.svg";
export { ForwardRef as ReactComponent };